import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as SearchIcon } from '../assets/icons/SearchIcon.svg';
import Fuse from "fuse.js";
import { fetchColeccionesGlobales } from "../services/dataCache";
export default function SearchBar({ searchText, setSearchText }) {
const navigate = useNavigate();
const containerRef = useRef(null);
const [inputValue, setInputValue] = useState(searchText);
const [allDocs, setAllDocs] = useState([]);
const [filteredDocs, setFilteredDocs] = useState([]);
const [openDropdown, setOpenDropdown] = useState(false);
const [fuse, setFuse] = useState(null);
useEffect(() => {
setInputValue(searchText);
}, [searchText]);
useEffect(() => {
const fetchAllDocs = async () => {
// Datos del caché compartido con Home: una sola descarga por sesión.
const cacheDocs = await fetchColeccionesGlobales();
const docsArray = cacheDocs.map((data) => ({
...data,
_fechaOrden: data.fecha_creacion || data.fechaCreacion || data.fecha || null,
}));
docsArray.sort((a, b) => {
if (!a._fechaOrden) return 1;
if (!b._fechaOrden) return -1;
return b._fechaOrden.toMillis() - a._fechaOrden.toMillis();
});
setAllDocs(docsArray);
setFilteredDocs(docsArray);
const fuseInstance = new Fuse(docsArray, {
// Solo los campos por los que tiene sentido buscar (antes indexaba TODOS los
// campos del primer doc, incluyendo objetos anidados: índice lento y ruidoso).
keys: ['id', 'nombre', 'apellido', 'razonSocial', 'coleccion'],
threshold: 0.3,
ignoreLocation: true,
});
setFuse(fuseInstance);
};
fetchAllDocs();
}, []);
useEffect(() => {
if (!fuse || inputValue.trim() === "") {
setFilteredDocs(allDocs.slice(0, 10));
} else {
const results = fuse.search(inputValue);
setFilteredDocs(results.slice(0, 10).map(r => r.item));
}
}, [inputValue, allDocs, fuse]);
useEffect(() => {
const handleClickOutside = (event) => {
if (containerRef.current && !containerRef.current.contains(event.target)) {
setOpenDropdown(false);
}
};
document.addEventListener("mousedown", handleClickOutside);
return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);
const handleSelect = (doc) => {
setOpenDropdown(false);
let path = "";
switch (doc.coleccion) {
case "stock":
path = `/stock`;
break;
case "clientes":
path = `/clientes/${doc.id}`;
break;
case "inventario":
path = `/inventario/${doc.id}`;
break;
case "ventas":
path = `/ventas`;
break;
case "vinificacion":
case "viticultura":
case "embotellado":
case "trazabilidad":
path = `/trazabilidad/${doc.id}`;
break;
case "compras":
path = `/compras`;
break;
default:
path = `/${doc.coleccion}/${doc.id}`;
break;
}
navigate(path);
};
const handleKeyDown = (e) => {
if (e.key === 'Enter') {
setSearchText(inputValue);
navigate('/');
setOpenDropdown(false);
}
};
const formatDate = (timestamp) => {
if (!timestamp) return 'Fecha no disponible';
const date = timestamp.toDate();
const day = String(date.getDate()).padStart(2, '0');
const month = String(date.getMonth() + 1).padStart(2, '0');
const year = date.getFullYear();
return `${day}/${month}/${year}`;
};

  const handleClearSearch = () => {
    setInputValue(''); // Vacía el estado del input.
    setSearchText(''); // Vacía el estado de búsqueda global si lo usas.
    setOpenDropdown(false); // Cierra el menú desplegable.
  };


return (
<div className={`search-bar-container ${openDropdown ? 'active' : ''}`} ref={containerRef}>
<div className={`search-input-wrapper ${openDropdown ? 'active' : ''}`}>
<SearchIcon className="search-icon" />
<input
type="text"
placeholder="¿Qué querés buscar?"
value={inputValue}
onChange={(e) => {
setInputValue(e.target.value);
setOpenDropdown(true);
}}
onFocus={() => {
// MODIFICACIÓN: Siempre abre el dropdown al recibir el foco
setOpenDropdown(true);
}}
onKeyDown={handleKeyDown}
className="search-input"
/>
{inputValue && ( // Esto hace que el botón solo aparezca cuando hay texto.
<button className="clear-search-button" onClick={handleClearSearch}>
&times;
</button>
)}</div>
{openDropdown && (
<div className="search-dropdown-options">
{filteredDocs.length > 0 ? (
filteredDocs.map(doc => {
let displayValue;
if (doc.coleccion === "clientes") {
displayValue = (doc.nombre && doc.apellido ? `${doc.nombre} ${doc.apellido}` : doc.razonSocial || doc.id);
} else if (doc.coleccion === "inventario") {
displayValue = `Inventario ${formatDate(doc.fecha)}`;
} else {
displayValue = doc.id;
}
return (
<div
key={doc.id + doc.coleccion}
className="search-dropdown-option"
onClick={() => handleSelect(doc)}
>
{displayValue}
</div>
);
})
) : (
<div className="search-dropdown-option">No se encontraron resultados</div>
)}
</div>
)}
</div>
);
}
